import React, { useRef } from 'react';
import { useDisclosure, Box } from '@chakra-ui/react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Mainindex from './components';



function App() {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const btnRef = useRef();
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Mainindex />} />
      </Routes>
    </Router>
  );
}

export default App;